window.initializeSwiperWhenVisible('.block__partners-info-row', () => {
  new Swiper('.block__partners-info-row', {
        loop: false,
        slidesPerView: 1.33, 
        paginationClickable: false,
        spaceBetween: 10,
        breakpoints: {
            1199: {
                slidesPerView: 4,
                spaceBetween: 10
            }, 
            992: {
                slidesPerView: 3,
                spaceBetween: 10
            }, 
            749: {
                slidesPerView: 2,
                spaceBetween: 10
            }, 
            480: {
                slidesPerView: 1,
                spaceBetween: 10
            }
        }
  });
});

window.initializeSwiperWhenVisible('.block__partners-info-slider', () => {
  new Swiper('.block__partners-info-slider', {
        loop: true,
        slidesPerView: "auto",
        paginationClickable: false,
        spaceBetween: 88,
        freeMode: false,
        autoplay: {
        delay: 0,
        },
        speed: 7000,
  });
});
